import CanvasHandler from "./CanvasHandler";
import { Seat } from "../canvas/channels";
import { FabricEvent } from "../types/FabricCustomType";
import { IObjectChannel } from "../types/HandlerObjectType";
import { isTouchInteraction } from "../utils/InteractionUtil";
import BaseObjectHandler from "./BaseObjectHandler";

class ChannelHandler extends BaseObjectHandler<IObjectChannel> {
  constructor(handler: CanvasHandler) {
    super(handler);
    this.objectTypes = {
      seat: new Seat(handler),
    };
  }

  public handleClickObject(event: FabricEvent<MouseEvent | TouchEvent>) {
    const isTouch = isTouchInteraction(event);
    if (event.target) {
      const { target: { superType } } = event;
      switch (superType) {
        case "row":
          const seat = event.subTargets?.find((t: any) => t?.superType === "seat");
          if (seat) {
            this.setType("seat");
            if (isTouch) {
              this.object.activateObjectHover(event, seat);
            } else {
              this.object.handleSelectObject(event, event.target.id, seat);
            }
          }

          break;
        default:
          if (isTouch) this.deactivateObjectHover();
          break;
      }
    } else {
      if (isTouch) this.deactivateObjectHover();
    }
  }

  public handleSelectObjects(event: FabricEvent) {
    this.setType("seat");
    if (this.object) {
      return this.object.handleSelectObjects(event);
    }

    return false;
  }

  public async handleSaveChanges() {
    this.setType("seat");
    await this.object.handleSaveChanges();
  }
}

export default ChannelHandler;
